import { template } from 'lodash4';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { APTermServant } from '../../../global/servants/ap_term_servant';
export class APTermRegistrationStatus {
  private term: APTerm;
  private hasPriorityReg: boolean;
  private isNotDefault: boolean;
  private inCountdownPeriod: boolean;
  private inPriorityPeriod: boolean;
  private isPriorityReg: boolean;
  private isStandardReg: boolean;
  private showTooltip: boolean;

  private statusText: {
    displayTitle: string;
    tooltipTitle: string;
    toolTipContent: string;
  };

  initialize() {
    const hasPriorityReg = APTermServant.hasPriorityReg(this.term);

    this.isNotDefault = APTermServant.hasDefaultRegistrationDates(this.term);
    this.inCountdownPeriod = APTermServant.inCountdownPeriod(this.term);
    this.inPriorityPeriod = APTermServant.inPriorityPeriod(this.term);
    this.isPriorityReg = hasPriorityReg;
    this.isStandardReg = !hasPriorityReg;
    this.showTooltip = this.term._termStatus.show_tooltip;
    this.statusText = {
      displayTitle: this.interpolateDates(this.term._termStatus.status_title),
      tooltipTitle: this.interpolateDates(this.term._termStatus.tooltip_title),
      toolTipContent: this.interpolateDates(this.term._termStatus.tooltip_content)
    };
  }
  private interpolateDates(tmplString: string) {
    const defaultDateFormat = 'MMMM DD, YYYY';
    const monthDay = 'MMMM DD';
    const preCalculatedTermDateInformation = {
      priority_registration_start_date: this.term.priority_registration_start_dt
        ? this.term.priority_registration_start_dt.format(monthDay)
        : '',
      priority_registration_end_date: this.term.priority_registration_end_dt
        ? this.term.priority_registration_end_dt.format(monthDay)
        : '',
      priority_registration_start_date_year: this.term.priority_registration_start_dt
        ? this.term.priority_registration_start_dt.format(defaultDateFormat)
        : '',
      priority_registration_end_date_year: this.term.priority_registration_end_dt
        ? this.term.priority_registration_end_dt.format(defaultDateFormat)
        : '',
      registration_start_date: this.term.registration_start_dt.format(monthDay),
      registration_end_date: this.term.registration_end_dt.format(monthDay),
      registration_start_date_year: this.term.registration_start_dt.format(defaultDateFormat),
      registration_end_date_year: this.term.registration_start_dt.format(defaultDateFormat),
      registration_time_until: this.getHumanTimeDiff(moment(), this.term.registration_start_dt),
      registration_time_left: this.getHumanTimeDiff(this.term.registration_start_dt, this.term.registration_end_dt),
      term_start_date: this.term.term_start_dt.format(monthDay),
      term_end_date: this.term.term_end_dt.format(monthDay),
      term_start_date_year: this.term.term_start_dt.format(defaultDateFormat),
      term_end_date_year: this.term.term_end_dt.format(defaultDateFormat),
      term_time_until: this.getHumanTimeDiff(moment(), this.term.term_start_dt),
      term_time_left: this.getHumanTimeDiff(this.term.term_start_dt, this.term.term_end_dt)
    };
    return template(tmplString, {
      interpolate: /{{([\s\S]+?)}}/g
    })(preCalculatedTermDateInformation);
  }
  private getHumanTimeDiff(startMoment: moment.Moment, endMoment: moment.Moment) {
    return moment.duration(endMoment.diff(startMoment)).humanize();
  }
  $onChanges() {
    this.initialize();
  }
  $onInit() {
    this.initialize();
  }
}

class APTermRegistrationStatusComponent implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: { term: string };
  constructor() {
    this.controller = APTermRegistrationStatus;
    this.templateUrl =
      'capability-ng-academic-planner/src/plan/components/term_registration_status/term_registration_status.html';
    this.bindings = { term: '<' };
  }
}

angular
  .module('capability-ng-academic-planner')
  .component('termRegistrationStatus', new APTermRegistrationStatusComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_registration_status/term_registration_status.ts